import { useEffect, useState } from 'react'
import { eqProps, uniqWith } from 'ramda'
import {
  AIR_SEARCH_DATA,
  getPersistedSearchDataByKeys,
  PERSISTED_SEARCH_KEY
} from '@/shared-utils/local-forage-helper'
import { Location } from '../server/utils/typeahead-fetch-types'

export default function useRecentSearches(key: PERSISTED_SEARCH_KEY) {
  const [recentStartLocations, setRecentStartLocations] = useState<Location[]>(
    []
  )
  const [recentEndLocations, setRecentEndLocations] = useState<Location[]>([])
  const isFlight = key === AIR_SEARCH_DATA

  useEffect(() => {
    getPersistedSearchDataByKeys([key], true).then(recentSearches => {
      if (recentSearches) {
        const startLocations = recentSearches
          .map(search =>
            isFlight ? search.flights[0].startLocation : search.startLocation
          )
          .filter(Boolean)
        const endLocations = recentSearches
          .map(search =>
            isFlight ? search.flights[0].endLocation : search.endLocation
          )
          .filter(Boolean)

        if (startLocations.length) {
          setRecentStartLocations(uniqWith(eqProps('itemName'), startLocations))
        }
        if (endLocations.length) {
          setRecentEndLocations(uniqWith(eqProps('itemName'), endLocations))
        }
      }
    })
  }, [key, isFlight])

  return [recentStartLocations, recentEndLocations]
}
